import { faFlask } from '@fortawesome/pro-regular-svg-icons';

import { FAIcon } from './fa-icon';

export const FlaskIcon = ({ width }: { width?: string }) => (
  <FAIcon icon={faFlask} width={width} />
);
